document.addEventListener('DOMContentLoaded', () => {
    // Находим ВСЕ контейнеры хотспотов на странице
    const hotspotsContainers = document.querySelectorAll('.hotspots-container');

    // === ФУНКЦИЯ ДЛЯ ПРОВЕРКИ И УСТАНОВКИ ПОЗИЦИИ ===
    // (Она остается такой же, как в прошлый раз)
    function calculatePosition(infoBox, button) {
        // Сначала всегда чистим классы
        infoBox.classList.remove('open-left', 'open-top');

        const viewportWidth = window.innerWidth;
        const viewportHeight = window.innerHeight;
        const buttonRect = button.getBoundingClientRect(); // Берем позицию самой КНОПКИ

        // 1. Проверка ВВЕРХ/ВНИЗ
        const isButtonInTopHalf = buttonRect.top < (viewportHeight / 2);

        if (!isButtonInTopHalf) {
            // Кнопка в нижней половине, открываем наверх
            infoBox.classList.add('open-top');
        }

        // 2. Проверка ВЛЕВО/ВПРАВО
        const isButtonInLeftHalf = buttonRect.left < (viewportWidth / 2);

        if (!isButtonInLeftHalf) {
            // Кнопка в правой половине, открываем влево
            infoBox.classList.add('open-left');
        }
    }

    // --- ГЛАВНЫЙ ЦИКЛ НАСТРОЙКИ ---
    // Проходим по каждому .hotspots-container
    hotspotsContainers.forEach(container => {

        // === ИСПРАВЛЕНИЕ: Слушатель анимации (теперь ВНУТРИ цикла) ===
        // Эта часть кода была в неправильном месте и ломала скрипт.
        container.querySelectorAll('.hotspot-info').forEach(infoBox => {
            infoBox.addEventListener('transitionend', () => {
                // Ждем, пока окно исчезнет, ПОТОМ убираем классы позиции
                if (!infoBox.classList.contains('is-visible')) {
                    infoBox.classList.remove('open-left', 'open-top');
                }
            });
        });

        // Настраиваем кнопки внутри этого .container
        const hotspotButtons = container.querySelectorAll('.hotspot-button');

        hotspotButtons.forEach(button => {
            button.addEventListener('click', (event) => {
                const infoBox = button.nextElementSibling;
                const isOpening = !infoBox.classList.contains('is-visible');

                // Закрываем все другие окна ВНУТРИ ЭТОГО КОНТЕЙНЕРА
                container.querySelectorAll('.hotspot-info.is-visible').forEach(openInfo => {
                    if (openInfo !== infoBox) {
                        openInfo.classList.remove('is-visible');
                    }
                });

                // Переключаем текущее
                infoBox.classList.toggle('is-visible');

                if (isOpening) {
                    if (window.innerWidth > 768) {
                        calculatePosition(infoBox, button);
                    }
                }


                event.stopPropagation(); // Остановка "всплытия" клика
            });
        });
    });

    // --- ОБЩИЕ СЛУШАТЕЛИ (ВНЕ ЦИКЛА) ---
    // Эти слушатели теперь находятся снаружи цикла, что более правильно.

    // Обработчик клика снаружи (один на всю страницу)
    document.addEventListener('click', (event) => {
        // Проверяем ВСЕ контейнеры
        hotspotsContainers.forEach(container => {
            container.querySelectorAll('.hotspot-info.is-visible').forEach(infoBox => {
                const button = infoBox.previousElementSibling;
                // Закрываем, если клик был не по инфо-боксу и не по его кнопке
                if (!infoBox.contains(event.target) && !button.contains(event.target)) {
                    infoBox.classList.remove('is-visible');
                }
            });
        });
    });

    // Обработчик изменения размера окна (один на всю страницу)
    window.addEventListener('resize', () => {
        // Проверяем ВСЕ контейнеры
        hotspotsContainers.forEach(container => {
            container.querySelectorAll('.hotspot-info.is-visible').forEach(infoBox => {
                const button = infoBox.previousElementSibling;
                // Пересчитываем позицию при ресайзе
                calculatePosition(infoBox, button);
            });
        });
    });

});